import {
  useTimelinePlayback,
  useVideoPlayback,
} from "@/contexts/playback-context";
import { useSelector } from "@legendapp/state/react";
import dayjs from "dayjs";

export function LatencyOverlay() {
  const videoPlayback = useVideoPlayback();
  const timelinePlayback = useTimelinePlayback();
  const currentTime = useSelector(
    () => timelinePlayback.currentTime && timelinePlayback.currentTime.get()
  );

  const videoStartTime = useSelector(() =>
    videoPlayback.videoContext.startTime.get()
  );

  if (!videoStartTime || !currentTime) return null;

  const difference = videoStartTime.getTime() - currentTime;

  if (difference <= 0) {
    return null;
  }

  return (
    <div className="absolute z-10 bg-black text-white flex items-center justify-center gap-2 aspect-video w-[350px]">
      <p>Video will be played in:</p>
      <span className="w-[100px] text-white slashed-zero tabular-nums select-none">
        {currentTime && videoStartTime
          ? dayjs
              .duration(difference)
              .format("HH[h]:mm:ss.SSS")
              .substring(0, 11)
              .replace(/\b00h:\b/, "")
          : ""}
      </span>
    </div>
  );
}
